const drmSupportLink = (drmPlatform, ubisoftSKA, epicSKA, bundleID, game) => {
  let supportLink = '';

  switch (drmPlatform) {
    case 'uplay':
      supportLink = '115005328429';
      break;
    case 'steam':
      supportLink = '201101161';
      break;
    case 'rockstar':
      supportLink = '214143285';
      break;
    case 'bethesda':
      supportLink = '360001626178';
      break;
    case 'esonline':
      supportLink = '206052731';
      break;
    case 'epicgames':
      supportLink = '360001750957';
      break;
    case 'origin':
      supportLink = '360003854337';
      break;
    case 'oculus':
      supportLink = '360001517398';
      break;
    case 'switch':
    case 'threeds':
      supportLink = '360001784478';
      break;
    case 'gog':
      if (game && game.vaultnKeyless) {
        supportLink = '16925718616594';
      } else {
        supportLink = '360004034038';
      }
      break;
    case 'magix':
      supportLink = '360005986058';
      break;
    case 'zenva':
      supportLink = '360006544458';
      break;
    case 'utalk':
      supportLink = '360006847857';
      break;
    case 'redeem':
      supportLink = '360000048985';
      break;
    case 'coupon':
      supportLink = '207848269';
      break;
    case 'drm_free':
      supportLink = '360001617598';
      break;
    case 'eaplay':
      supportLink = '14353191464466';
      break;
    case 'runescape':
      supportLink = '17682773071122';
      break;
    case 'xbox':
      supportLink = '15813504401425';
      break;
    case 'microsoft':
      supportLink = '19033784487954';
      break;
    case 'drivethrurpg':
      supportLink = '22130824846866';
      break;
    case 'idw':
      supportLink = '23324336331538';
      break;
    default:
      supportLink = '115005335525';
  }

  if (ubisoftSKA) return '360000066997';
  if (epicSKA) return '360007075098';
  if (bundleID === '606ed0be9c233e007d2bfb51') return '360018925977';

  return supportLink;
};

export default drmSupportLink;
